const text = (value) => String(value || "").trim();

export const resumeProgramLabCheckout = (saved, step) => {
  const address = saved?.address || {};
  const requirements = new Map((step?.availability?.requirements || []).map(
    (item) => [text(item.requirement_id), item],
  ));
  const releasedLabs = new Map();
  (step?.program_labs || []).forEach((program) => {
    (program.labs || []).forEach((lab) => {
      [lab.assignment_id, lab.requirement_id].filter(Boolean).forEach((id) => {
        releasedLabs.set(text(id), lab);
      });
    });
  });

  const labDetails = Object.fromEntries(
    Object.entries(saved?.labs || {}).map(([key, detail]) => {
      const lab = releasedLabs.get(key);
      const requirement = requirements.get(text(lab?.requirement_id));
      const decisionId = text(detail?.availabilityDecisionId);
      const current = detail?.selected === true
        && decisionId
        && requirement?.status === "available"
        && text(requirement.decision_id) === decisionId;
      return [key, {
        ...detail,
        ...(current ? {
          availability: {
            is_available: true,
            policy_fingerprint: text(detail.availabilityFingerprint),
            resolved_state: text(address.state).toUpperCase(),
            source: "runtime_saved",
            saved_method: text(detail.selectedMethod),
            saved_assignment_id: text(detail.selectedAssignmentId),
          },
        } : {}),
      }];
    }),
  );
  const selected = Object.values(labDetails).filter((detail) => detail?.selected);
  const checkedZips = [...new Set(selected.map((detail) => text(detail.collectionZip)))];
  const availabilityZip = checkedZips.length === 1 ? checkedZips[0] : "";
  const verifiedAddress = ["street", "city", "state", "zip"]
    .every((key) => text(address[key]));

  return {
    ...saved,
    lab_stage: "consents",
    lab_details: labDetails,
    ...(availabilityZip ? { availability_zip: availabilityZip } : {}),
    ...(verifiedAddress ? {
      address_verification: {
        fingerprint: [address.street, address.city, address.state, address.zip].join("|"),
        address: { ...address },
        source: "runtime_saved",
      },
    } : {}),
  };
};
